import { app } from '../../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.directory-integration.manage.domains.delete-domain', {
        url: '/delete-domain/:domainId',
        views: {
            '@company.directory-integration.manage': 'companyDirectoryIntegrationManageDomainsDeleteDomain'
        },
        resolve: {
            domain,
            domainId,
        },
    });
}

/** @ngInject */
function domain(domainId, domains) {
    return domains.find((domain) => domain.id === domainId);
}

/** @ngInject */
function domainId($stateParams) {
    return $stateParams.domainId;
}



// WEBPACK FOOTER //
// ./src/portal/states/company/directory-integration/manage/domains/delete-domain/delete-domain.state.js